import React, { Component } from 'react';
import './App.css';
import Seat from './Seat';
import DealerActions from './DealerActions';
import PlayerActions from './PlayerActions';
import { tableState as apiTableState, joinTable } from './api';
import Loading from './Loading';
import Modal from 'react-modal';
import { HelpCircle } from 'react-feather';
import SocketIOClient from 'socket.io-client';
import getConfig from './config';
import { numActivePlayers } from './common';

var openTokApiKey = '46592742';
const config = getConfig();
const socket = SocketIOClient(config.apiServerBase);

export enum SeatState {
  EMPTY = 'empty',
  ACTIVE = 'active',
  FOLDED = 'folded',
  SHOW = 'show',
}

interface Seat {
  seatIndex: number;
  state: SeatState;
  name: string;
  chips: number;
  currentPot: number;
  cards: string[];
  handDescription?: string;
}

function preLoadCardImages() {
  const cards = [
    'TC.png',
    'TD.png',
    'TH.png',
    'TS.png',
    '2C.png',
    '2D.png',
    '2H.png',
    '2S.png',
    '3C.png',
    '3D.png',
    '3H.png',
    '3S.png',
    '4C.png',
    '4D.png',
    '4H.png',
    '4S.png',
    '5C.png',
    '5D.png',
    '5H.png',
    '5S.png',
    '6C.png',
    '6D.png',
    '6H.png',
    '6S.png',
    '7C.png',
    '7D.png',
    '7H.png',
    '7S.png',
    '8C.png',
    '8D.png',
    '8H.png',
    '8S.png',
    '9C.png',
    '9D.png',
    '9H.png',
    '9S.png',
    'AC.png',
    'AD.png',
    'AH.png',
    'AS.png',
    'JC.png',
    'JD.png',
    'JH.png',
    'JS.png',
    'KC.png',
    'KD.png',
    'KH.png',
    'KS.png',
    'QC.png',
    'QD.png',
    'QH.png',
    'QS.png',
  ];
  cards.forEach(c => {
    const image = new Image();
    image.src = `/assets/${c}`;
    image.alt = c;
  });
}

export interface TableState {
  sessionId?: string;
  mySessionToken?: string;
  mySeatIndex: number;
  tableId: string;
  isDealer: boolean;
  createdAt: number;
  pot: number;
  dealerSeatIndex: number;
  smallBlindIndex: number;
  bigBlindIndex: number;
  communityCards: string[];

  seats: Seat[];
}

interface State {
  tableState?: TableState;
  errorMessage?: string;
  isIntroModalOpen: boolean;
  isHelpModalOpen: boolean;
}

let videoLoaded = config.useMockData ? true : false;

class App extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      isIntroModalOpen: config.useMockData ? false : true,
      isHelpModalOpen: false,
    };
  }

  async componentDidMount() {
    try {
      const tableId = window.location.pathname.substring(3);
      await joinTable(tableId);
      preLoadCardImages();

      socket.on('update', (newState: TableState) => {
        this.setState({
          tableState: newState,
        });
      });

      if (config.useMockData) {
        const mockData = require('./mockData').default;
        this.setState({
          tableState: mockData,
        });
      } else {
        const newState = await apiTableState();
        socket.emit(`joinTable`, `${tableId}.${newState.mySeatIndex}`);
        this.setState({
          tableState: newState,
        });
      }
    } catch (e) {
      //alert('Table not found or has expired');
      this.setState({
        errorMessage: 'Oops. Table not found or the game has ended.',
      });
    }
  }

  getSeats() {
    const { tableState } = this.state;
    if (tableState) {
      const seats = tableState!.seats.map((s, i) => {
        return (
          <Seat
            key={i}
            index={i}
            state={s.state}
            name={s.name}
            chips={s.chips}
            currentPot={s.currentPot}
            cards={s.cards}
            handDescription={s.handDescription}
            isCurrentlySeated={
              !(
                tableState!.mySessionToken === undefined ||
                tableState!.mySessionToken === null
              )
            }
            isDealer={i === tableState!.dealerSeatIndex}
            isSmallBlind={i === tableState!.smallBlindIndex}
            isBigBlind={i === tableState!.bigBlindIndex}
            onSeated={async () => {
              socket.emit(`joinTable`, `${tableState.tableId}.${i}`);
              const newState = await apiTableState();
              this.setState({
                tableState: newState,
              });
            }}
            onOpenIntroModal={() => this.setState({ isIntroModalOpen: true })}
          />
        );
      });
      return seats;
    }
  }

  introModal() {
    return (
      <Modal
        portalClassName={'intro-modal'}
        isOpen={this.state.isIntroModalOpen}
        onRequestClose={() => this.setState({ isIntroModalOpen: false })}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '650px',
            textAlign: 'center',
          },
        }}
      >
        <img alt="" width={200} src="/assets/aces.png" />
        <div className="intro-row">
          <div className="intro-q">What is Pokerona?</div>
          <div className="intro-a">
            Pokerona let’s you enjoy some facetime with friends and play a game
            of poker while social distancing.
          </div>
        </div>
        <div className="intro-row">
          <div className="intro-q">Is it like online poker?</div>
          <div className="intro-a">
            No! Pokerona was created specifically to give you the feeling of
            playing poker face to face.
            <br />
            <br />- There are no timers, predefined buttons to check, raise or
            auto add small/blind.
            <br />- You are expected to talk other via video and play like how
            you would at a real table and ensure everyone adds the correct
            amount to the pot.
            <br />
            -We take care of shuffling the deck, dealing cards and ensure no one
            sees your cards.
          </div>
        </div>
        <div className="intro-row">
          <div className="intro-q">How can I invite someone to my table?</div>
          <div className="intro-a">
            Share this link with them - <b>{window.location.href}</b>
          </div>
        </div>
        <button
          onClick={async () => {
            window.document.documentElement.requestFullscreen();
            this.setState({ isIntroModalOpen: false });
          }}
        >
          Sounds good
        </button>
      </Modal>
    );
  }

  helpModal() {
    return (
      <Modal
        portalClassName={'help-modal'}
        isOpen={this.state.isHelpModalOpen}
        onRequestClose={() => this.setState({ isHelpModalOpen: false })}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '560px',
            textAlign: 'center',
          },
        }}
      >
        <img alt="" width={200} src="/assets/aces.png" />
        <div className="intro-row">
          <div className="intro-q">How can I invite someone to my table?</div>
          <div className="intro-a">
            Share this link with them - <b>{window.location.href}</b>
          </div>
        </div>
        <div className="intro-row">
          <div className="intro-q">Why is my video not working?</div>
          <div className="intro-a">
            Your browser may not have access to your camera. Click{' '}
            <a
              href="https://www.google.com/search?q=how+to+enable+camera+microphone+on+my+browser"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>{' '}
            for instructions.
          </div>
        </div>
        <div className="intro-row">
          <div className="intro-q">Can I play on my phone?</div>
          <div className="intro-a">
            Unfortunately, no. Pokerona was build to provide both comfortable
            play and socializing. We feel holding a phone up for long is not
            comfortable.
          </div>
        </div>
        <div className="intro-row">
          <div className="intro-q">Found a bug or want to share feedback?</div>
          <div className="intro-a">
            We're all ears - Click{' '}
            <a
              href="https://sharathprabhal.typeform.com/to/UTwxep"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>{' '}
            to provide feedback.
          </div>
        </div>
        <button
          onClick={async () => {
            this.setState({ isHelpModalOpen: false });
          }}
        >
          OK
        </button>
      </Modal>
    );
  }

  dealerActions() {
    const { tableState } = this.state;
    return (
      tableState &&
      tableState.isDealer && <DealerActions tableState={tableState} />
    );
  }

  playerActions() {
    const { tableState } = this.state;
    return (
      tableState && (
        <PlayerActions
          tableState={tableState}
          onStandup={async () => {
            const newState = await apiTableState();
            socket.emit(
              `joinTable`,
              `${newState.tableId}.${newState.mySeatIndex}`,
            );
            this.setState({
              tableState: newState,
            });
            window.location.reload();
          }}
        />
      )
    );
  }

  render() {
    const { tableState } = this.state;
    if (
      !videoLoaded &&
      tableState &&
      tableState.sessionId &&
      tableState.mySessionToken
    ) {
      videoLoaded = true;
      setTimeout(() => {
        // setup connection
        // @ts-ignore
        const OT = window.OT;
        var session = OT.initSession(openTokApiKey, tableState.sessionId);

        // create publisher
        var publisher = OT.initPublisher(
          `seat-${tableState.mySeatIndex + 1}-video`,
          {
            name: tableState.mySeatIndex + 1,
            insertMode: 'append',
          },
        );
        session.connect(tableState.mySessionToken, function(err: any) {
          err && console.error('connect error', err);
          // publish publisher
          session.publish(publisher);
        });

        session.on('streamCreated', function(event: any) {
          session.subscribe(
            event.stream,
            `seat-${parseInt(event.stream.name, 10)}-video`,
            {
              insertMode: 'append',
            },
          );
        });
      }, 1000);
    }

    if (!tableState) {
      return (
        <div className="home">
          <Loading />
          <br />
          {this.state.errorMessage}
        </div>
      );
    }
    return (
      <>
        <div
          className="table-help"
          onClick={() => this.setState({ isHelpModalOpen: true })}
        >
          <HelpCircle size={20} />
          &nbsp; Help
        </div>
        {this.introModal()}
        {this.helpModal()}

        <div className="game-container">
          {tableState.mySessionToken && (
            <div className="actions-container">
              {numActivePlayers(tableState) === 1 && (
                <div className="invite-players blink">
                  Invite other players to get started!
                </div>
              )}
              <br />
              {this.playerActions()}
              <br />
              {this.dealerActions()}
            </div>
          )}

          <div className="table-container">
            <div
              className="table"
              style={{ backgroundImage: `url('/assets/poker-table.png')` }}
            >
              {this.getSeats()}
              <div className="board">
                {tableState!.communityCards.length >= 3 && (
                  <>
                    <div
                      className="flop-1 board-card"
                      style={{
                        backgroundImage: `url('/assets/${
                          tableState!.communityCards[0]
                        }.png')`,
                      }}
                    />
                    <div
                      className="flop-2 board-card"
                      style={{
                        backgroundImage: `url('/assets/${
                          tableState!.communityCards[1]
                        }.png')`,
                      }}
                    />
                    <div
                      className="flop-3 board-card"
                      style={{
                        backgroundImage: `url('/assets/${
                          tableState!.communityCards[2]
                        }.png')`,
                      }}
                    />
                  </>
                )}
                {tableState!.communityCards.length >= 4 && (
                  <>
                    <div
                      className="turn board-card"
                      style={{
                        backgroundImage: `url('/assets/${
                          tableState!.communityCards[3]
                        }.png')`,
                      }}
                    />
                  </>
                )}
                {tableState!.communityCards.length === 5 && (
                  <>
                    <div
                      className="river board-card"
                      style={{
                        backgroundImage: `url('/assets/${
                          tableState!.communityCards[4]
                        }.png')`,
                      }}
                    />
                  </>
                )}
              </div>
              <div className="pot">
                Total pot: <b>${tableState!.pot}</b>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default App;
